import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';

export interface IAlterationEntitlementRedemptionEntityAttributes extends IModelAttributes {
	unitsRedeemed: number;
	alterationId: string;
	alteration?: Models.AlterationEntity | Models.IAlterationEntityAttributes;
	userEntitlementId: string;
	userEntitlement?: Models.UserEntitlementEntity | Models.IUserEntitlementEntityAttributes;
}

@entity('AlterationEntitlementRedemptionEntity', 'Alteration Entitlement Redemption')
export default class AlterationEntitlementRedemptionEntity
	extends Model
	implements IAlterationEntitlementRedemptionEntityAttributes
{
	public static excludeFromCreate: string[] = [];
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute<AlterationEntitlementRedemptionEntity, number>()
	public unitsRedeemed: number;

	@observable
	@attribute()
	public alterationId: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public alteration?: Models.AlterationEntity;

	@observable
	@attribute()
	public userEntitlementId: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public userEntitlement?: Models.UserEntitlementEntity;

	constructor(attributes?: Partial<IAlterationEntitlementRedemptionEntityAttributes>) {
		super(attributes);
		makeObservable(this);
		this.assignAttributes(attributes);
	}

	public assignAttributes(attributes?: Partial<IAlterationEntitlementRedemptionEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.unitsRedeemed !== undefined) {
				this.unitsRedeemed = attributes.unitsRedeemed;
			}
			if (attributes.alterationId !== undefined) {
				this.alterationId = attributes.alterationId;
			}
			if (attributes.alteration !== undefined) {
				if (attributes.alteration === null) {
					this.alteration = undefined;
				} else if (attributes.alteration instanceof Models.AlterationEntity) {
					this.alteration = attributes.alteration;
					this.alterationId = attributes.alteration.id;
				} else {
					this.alteration = new Models.AlterationEntity(attributes.alteration);
					this.alterationId = this.alteration.id;
				}
			}
			if (attributes.userEntitlementId !== undefined) {
				this.userEntitlementId = attributes.userEntitlementId;
			}
			if (attributes.userEntitlement !== undefined) {
				if (attributes.userEntitlement === null) {
					this.userEntitlement = undefined;
				} else if (attributes.userEntitlement instanceof Models.UserEntitlementEntity) {
					this.userEntitlement = attributes.userEntitlement;
					this.userEntitlementId = attributes.userEntitlement.id;
				} else {
					this.userEntitlement = new Models.UserEntitlementEntity(attributes.userEntitlement);
					this.userEntitlementId = this.userEntitlement.id;
				}
			}
		}
	}
}
